import React, { useState } from "react";
import { LoadingSpinner } from "lib/Spinner";
import { ViewLayout } from "components/ViewLayout/ViewLayout";
import { AutoCompleteSearchBox } from "components/AutoCompleteSearchBox/AutoCompleteSearchBox";
import { TileView } from "components/TileView/TileView";
import { NotAvailable } from "lib/SimpleTable";
import { titleFromPath } from "app/header/parts/HeaderTitle";
import { getPathname } from "lib/routing";
import { useFetch } from "lib/useFetch";
import { features } from "app/features";
import { useAdverts, contains } from "pages/Ads/Adverts/useAdverts";
import { Row } from "react-bootstrap";
import { usePocGetPublications } from "pages/LandingPage/parts/usePocGetPublicationsApi";
import { AdvertCarousel } from "pages/Ads/Adverts/AdvertBanner";
import { sanitizeHtml } from "utils/sanitizeHtml";

export function LandingPublications({ searchResults }) {
  const publications = searchResults?.[0];

  return (
    <section>
      <ViewLayout publications={publications} data={searchResults} hideAds />
    </section>
  );
}

export const LandingPageAdverts = ({ advertIds }) => {
  let adverts = useAdverts();
  const [selectedAd, setSelectedAd] = useState(0);
  const next = () => setSelectedAd(selectedAd < adverts.length ? selectedAd + 1 : 0);

  adverts = adverts && adverts.filter((ad) => contains(advertIds, ad.id.toString()));
  if (!adverts || !adverts.length) return null;

  return (
    <Row className="mx-n2">
      <AdvertCarousel adverts={adverts} next={next} />
    </Row>
  );
};

export const PocHashtagPublications = ({ hashtags }) => {
  const search = "?q=hashtags:(" + hashtags.join(" OR ") + ")";
  const [publications] = usePocGetPublications(search);
  const featuredPubs = publications.filter((pub) => pub.featured).map(styleAsPromo);
  const unfeaturedPubs = publications.filter((pub) => !pub.featured);

  return (
    <>
      {featuredPubs.length ? (
        <section>
          <h5 className="font-weight-lighter mb-3">Featured Reports</h5>
          <TileView publications={featuredPubs} />
        </section>
      ) : null}

      {unfeaturedPubs.length ? (
        <section>
          <h5 className="font-weight-lighter px-2 mb-1">{titleFromPath(getPathname())}</h5>
          <AutoCompleteSearchBox placeholder="Search within this section..." />
          <ViewLayout publications={unfeaturedPubs} hideAds />
        </section>
      ) : null}
    </>
  );
};

export const PocHtmlContent = ({ filename }) => {
  const url =
    (features.useJsApiFor[filename] ? "/research/jsapi/public/" : process.env.PUBLIC_URL + "/api/jsapi/") + filename;
  let [html, isLoading, error] = useFetch(url, undefined, "GET", undefined, undefined, false);

  if (isLoading) return <LoadingSpinner />;
  if (error) return <NotAvailable />;

  //if (filename === "WAAG_2021new.htm") return <EconomicForcastPoc filename={filename} html={html} />;

  return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />;
};

const styleAsPromo = (pub) => ({ ...pub, style: "darkPromo" });
